import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { AutorizacaoService } from '@shared/infra/autorizacao/autorizacao.service';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { trackById } from '@vex/utils/track-by';
import { SliceAuthService } from '../../../../../core/autenticacao/slice-auth.service';
import { NavigationSubheading } from '../../../../../core/navigation/navigation-item.interface';
import { NavigationService } from '../../../../../core/navigation/navigation.service';
import { MenuItem } from '../interfaces/menu-item.interface';

const MENU_ITEM_MINHA_CONTA = {
  id: '1',
  icon: 'mat:account_circle',
  label: 'Minha Conta',
  description: 'Informações pessoais',
  colorClass: 'text-primary-600',
  route: '/admin/minha-conta',
};

const MENU_ITEM_CONFIGURACOES = {
  id: '2',
  icon: 'mat:settings',
  label: 'Configurações',
  description: 'Informações do sistema',
  colorClass: 'text-primary-600',
  route: '/admin/config',
};

const MENU_ITEM_CONTROLE_ACESSO = {
  id: '3',
  icon: 'mat:admin_panel_settings',
  label: 'Controle de Acesso',
  description: 'Usuários e perfis',
  colorClass: 'text-primary-600',
  route: '/admin/acesso',
};

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatRippleModule,
    RouterLink,
    NgClass,
  ],
})
export class ToolbarUserDropdownComponent implements OnInit {
  private authService = inject(SliceAuthService);
  private autorizacaoService = inject(AutorizacaoService);
  private navigationService = inject(NavigationService);

  usuarioLogado = this.authService.usuarioLogado;
  perfilUsuarioLogado = this.autorizacaoService.perfilUsuarioLogado;

  items: MenuItem[] = [];

  trackById = trackById;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>
  ) {
    this.navigationService.itemsAdmin$.pipe(takeUntilDestroyed()).subscribe({
      next: (items) => {
        const config = items.find(
          (i) => i.type === 'subheading' && i.id === 'config'
        ) as NavigationSubheading;
        const acessos = items.find(
          (i) => i.type === 'subheading' && i.id === 'acesso'
        ) as NavigationSubheading;
        if (config?.children.length > 0 && acessos?.children.length > 0) {
          this.items = [
            MENU_ITEM_MINHA_CONTA,
            MENU_ITEM_CONFIGURACOES,
            MENU_ITEM_CONTROLE_ACESSO,
          ];
        } else if (config?.children.length > 0) {
          this.items = [MENU_ITEM_MINHA_CONTA, MENU_ITEM_CONFIGURACOES];
        } else if (acessos?.children.length > 0) {
          this.items = [MENU_ITEM_MINHA_CONTA, MENU_ITEM_CONTROLE_ACESSO];
        } else {
          this.items = [MENU_ITEM_MINHA_CONTA];
        }
      },
    });
  }

  ngOnInit() {}

  logout() {
    this.authService.logout();
  }

  close() {
    this.popoverRef.close();
  }
}
